import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { storage } from "../../lib/api";
import { Card, Button } from "../../components/ui";
import Icon from "../../components/Icon";

export default function Kiosk() {
  const { family } = useAuth();
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);

  const setupKiosk = () => {
    if (!family?.access_code) return;
    storage.set("choremouse_kiosk", family.access_code);
    toast.success("Kiosk on! Opening the kids' screen…");
    navigate("/kids");
  };
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(`${window.location.origin}/kids?kiosk=${family?.access_code}`);
      setCopied(true); setTimeout(() => setCopied(false), 2000);
    } catch (e) { toast.error("Couldn't copy — type the code on the device instead."); }
  };

  return (
    <div className="space-y-6" data-testid="kiosk-page">
      <div>
        <h1 className="font-heading font-black text-3xl text-ink">Kids' device</h1>
        <p className="text-ink-soft font-medium mt-1">Turn a phone or tablet into a tap-and-go screen for your kids — no code to remember.</p>
      </div>

      <Card kid className="p-6 text-center">
        <span className="inline-grid place-items-center w-14 h-14 rounded-2xl bg-primary/15 text-primary mb-3"><Icon name="tablet-smartphone" width={28} height={28} /></span>
        <div className="text-xs font-black uppercase tracking-widest text-ink-muted">Family code</div>
        <div className="font-heading font-black text-4xl tracking-[0.25em] text-primary-dark mb-4">{family?.access_code}</div>
        <Button size="lg" className="w-full mb-2" onClick={setupKiosk} data-testid="setup-kiosk"><Icon name="tablet" width={18} height={18} /> Set up kiosk on THIS device</Button>
        <Button size="lg" variant="outline" className="w-full" onClick={copyLink} data-testid="copy-kiosk-link"><Icon name="link" width={18} height={18} /> {copied ? "Link copied!" : "Copy kiosk link for another device"}</Button>
      </Card>

      <Card className="p-5">
        <div className="flex items-center gap-2 mb-2"><Icon name="info" className="text-primary" width={20} height={20} /><span className="font-heading font-extrabold text-lg text-ink">How it works</span></div>
        <ol className="text-sm text-ink-soft font-medium space-y-2 list-decimal pl-5">
          <li>On your kid's device, tap <b>Set up kiosk on THIS device</b> (or open the copied link there).</li>
          <li>The device remembers your family — kids just open ChoreMouse and tap their name.</li>
          <li>Set a PIN per kid in <b>Settings → Family</b> so only they can open their profile.</li>
        </ol>
      </Card>
    </div>
  );
}
